export default {
    data() {
        return {
            contractStateList: [    //合同状态
                {
                    label: '签署中',
                    value: 'IN_PROGRESS',
                    color: '#0062FF'
                },
                {
                    label: '签署完成',
                    value: 'FINISHED',
                    color: '#00C152'
                },
                {
                    label: '已撤消',
                    value: 'CANCELED',
                    color: '#999999'
                },
                // {
                //     label: '终止',
                //     value: 'TERMINATED',
                //     color: '#FF0D0D'
                // },
                // {
                //     label: '过期',
                //     value: 'EXPIRED',
                //     color: '#666'
                // },
                // {
                //     label: '拒签',
                //     value: 'REFUSED',
                //     color: '#FF0D0D'
                // }
            ],
            insuranceState: [{   //合同宝状态
                label: '未保障',
                value: 0,
            },
            // {
            //     label: '不可投保',
            //     value: 1,
            // },
            {
                label: '保障中',
                value: 2,
            },
            {
                label: '已到期',
                value: 3,
            },
            {
                label: '启动维权',
                value: 4,
            },
            {
                label: '部分退款',
                value: 5,
            },
            {
                label: '全额退款',
                value: 6,
            }],
            certificateType: [  //出证类型
                {
                    label: '电子版',
                    value: 0
                },
                {
                    label: '纸质版',
                    value: 1
                }
            ],
            certificateState: [
                {
                    label: '未付款',
                    value: 0
                },
                {
                    label: '出证中',
                    value: 1
                },
                {
                    label: '已交付',
                    value: 2
                }
            ],
            transactionType: [  //消费类型
                {
                    label: '法务咨询',
                    value: "1"
                },
                {
                    label: '三要素核验',
                    value: "2"
                },
                {
                    label: '合同',
                    value: "3"
                },
                {
                    label: '合同保障',
                    value: "4"
                },
                {
                    label: '出证',
                    value: "5"
                },
                {
                    label: '课程',
                    value: "6"
                },
                {
                    label: '权益执行',
                    value: "7"
                }
            ],
            payType: [{
                label: '余额',
                value: 1
            },
            {
                label: '支付宝',
                value: 2
            }],
            enforceType: [
                {
                    label: '法院判决',
                    value: 1
                }, {
                    label: '商事仲裁',
                    value: 2
                }
            ],
            subjectType: [{
                label: '法人',
                value: 1
            },
            {
                label: '自然人',
                value: 2
            }],
            //推广收益类型
            rewardRecordType: [
                {
                    label: '首次支付',
                    value: 1
                },
                {
                    label: '充值',
                    value: 2
                },
                {
                    label: '法律咨询',
                    value: 3
                },
                {
                    label: '电子合同',
                    value: 4
                },
                {
                    label: '提现',
                    value: -1
                },
                {
                    label: '提现到余额',
                    value: -2
                }
            ],
            // 代金券类型
            voucherTypeData: [
                {
                    label: '通用代金券',
                    value: 0
                },
                {
                    label: '法律咨询-代金券',
                    value: 1
                },
                {
                    label: '电子合同-代金券',
                    value: 2
                }
            ],
            //代金券来源
            voucherSourceData: [
                {
                    label: '活动购买',
                    value: 0
                },
                {
                    label: '系统赠送',
                    value: 1
                },
                {
                    label: '帐号赠送',
                    value: 2
                }
            ],
            // 代金券状态
            voucherStateData: [
                {
                    label: '可使用',
                    value: '0'
                },
                {
                    label: '已使用',
                    value: '1'
                },
                {
                    label: '已过期',
                    value: '2'
                }
            ],
            employeeType: [
                {
                    label: '正常',
                    value: 0
                },
                {
                    label: '停用',
                    value: 1
                }
            ],
            idType: [
                {
                    label: '中国大陆居民身份证',
                    value: 'CRED_PSN_CH_IDCARD'
                },
                {
                    label: '香港来往大陆通行证',
                    value: 'CRED_PSN_CH_HONGKONG'
                },
                {
                    label: '澳门来往大陆通行证',
                    value: 'CRED_PSN_CH_MACAO'
                },
                {
                    label: '台湾来往大陆通行证',
                    value: 'CRED_PSN_CH_TWCARD'
                },
                {
                    label: '护照',
                    value: 'CRED_PSN_PASSPORT'
                }
            ],
            //广场发布状态
            plazaessageStatus: [
                {
                    label: '已发布',
                    value: '1'
                },
                {
                    label: '审核中',
                    value: '0'
                }, {
                    label: '未通过',
                    value: '2'
                }

            ],
            // 发票类型
            InvoiceTypeList: [
                {
                    value: 1,
                    label: '普通发票-电子',
                },
                {
                    value: 2,
                    label: '专用发票-电子',
                },
            ],
            InvoiceTitleTypeList: [
                {
                    value: 1,
                    label: '单位',
                },
                {
                    value: 2,
                    label: '个人/事业单位',
                },
            ]

        }
    },
    methods: {
        EnumRender(res, list) {
            if (!list.length) {
                return "--"
            }
            const item = list.find(item => item.value == res)
            if (!item) {
                return "--"
            }
            return item.label
        },
        voucherTypeRender(data) {
            const item = this.voucherTypeData.find((res) => res.value == data.type);
            let style = "";
            if (item.value === 1) {
                style =
                    "color:#914F1A;";
            }
            if (item.value === 2) {
                style = "color: #0062FF;";
            }
            return `<span style="${style}">${item.label}</span>`;
        },
        voucherStateDataRender(data) {
            const item = this.voucherStateData.find((res) => res.value == data.state);
            console.log(item)
            const textrender = (color, text) =>
                `<div style="gap: 5px;display: flex;align-items: center;"><div style="width: 5px;height: 5px;border-radius: 50%;background: ${color};"></div><div style="color: ${color};">${text}</div></div>`;
            if (item.value == 0) {
                return textrender("#0062FF", item.label);
            }
            if (item.value == 1) {
                return textrender("#666666", item.label);
            }
            if (item.value == 2) {
                return textrender("#F45858", item.label);
            }
            return "--";
        },
        plazaessageStatusRender(data) {
            const item = this.plazaessageStatus.find((res) => res.value == data.status);
            let style = "";
            if (item.value === '0') {
                style =
                    "color:#914F1A;";
            }
            if (item.value === '1') {
                style = "color: #0062FF;";
            }
            if (item.value === '2') {
                style = "color: #F45858;";
            }
            return `<span style="${style}">${item.label}</span>`;
        },
        voucherAmountRender({ amount, type }) {
            let style = "";
            if (type === 1) {
                style = "color:#914F1A;";
            }
            if (type === 2) {
                style = "color: #0062FF;";
            }
            return `<span style="${style}">¥${this.$utils.priceFormat(amount, 2)}</span>`;
        },
        certificateTypeRender(value) {
            const item = this.certificateType.find((res) => res.value == value);
            let style = "";
            if (value == 0) {
                style = "color: #0062FF;text-decoration: underline;";
            }
            if (value == 1) {
                style = "color: #262626;";
            }
            return `<span style="${style}">${item.label}</span>`;
        },
        certificateStateRender(value) {
            const item = this.certificateState.find((res) => res.value == value);
            const textrender = (color, background, text) =>
                `<div style="height:22px;display: inline-block;line-height: 22px;border-radius: 22px;padding: 0 10px;background: ${background};color: ${color};font-size: 12px;">${text}</div>`;
            if (item.value == 0) {
                return textrender("#F45858", "#FDEBEB", item.label);
            }
            if (item.value == 1) {
                return textrender("#0062FF", "#E8F3FF", item.label);
            }
            if (item.value == 2) {
                return textrender("#00C152", "#E8FAEF", item.label);
            }
        },
    }
}